import React, { useEffect, useState, useRef } from "react";
import { bm_date, convertDate, cycleArray, getToday, getYesterday } from "../utils/Utils";
import dayjs from "dayjs";

const DateInput = React.forwardRef((props, ref) => {
    const {
        value: propValue = "",
        width = 95,
        className = "",
        secondary = false,
        warning = false,
        black = false,
        style = {},
        right = false,
        medium,
        edit = false,
        placeholder = "MM/DD/YY",
        onChange = () => { },
        onFilled = () => { },
        onPreFilled = () => { },
        onClick = () => { },
        onFocus = () => { },
        onBlur = () => { },
        onPageUp = () => {},
        onCycle = false,
        pageupcycle = true,
        onEnter = null,
        controlled = false,
        render = false,
        autoselect = false,
        autofocus = false,
        grow = false,
        shrink = true,
        opened = false,
        cycle = ["today"],
        show_preset = false,
    } = props;

    const toDisplay = (val) => convertDate(val, "YYYY-MM-DD", "MM/DD/YY");
    const toValue = (val) => convertDate(val, "MM/DD/YY", "YYYY-MM-DD");

    const resolveCycleItem = (item) => {
        if (item === 'today') {
            return getToday();
        }
        if (item === 'yesterday') {
            return getYesterday();
        }
        return item;
    };

    const [value, setValue] = useState(toDisplay(propValue));
    const [isFocused, setIsFocused] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const inputRef = useRef(null);

    useEffect(() => {
        if (!isFocused) {
            setValue(toDisplay(propValue));
        }

    }, [propValue, isFocused]);

    const filterDate = (val) => {
        const digits = val.replace(/\D/g, "").slice(0, 6);
        let formatted = digits.slice(0, 2);
        if (digits.length > 2) formatted += "/" + digits.slice(2, 4);
        if (digits.length > 4) formatted += "/" + digits.slice(4, 6);
        return formatted;
    };

    const handleChange = (e, _truncate = false) => {

        const input = e.target;
        const cursorPos = input.selectionStart;
        const val = e.target.value;
        let digitsBefore = 0;
        for (let i = 0; i < cursorPos; i++) {
            if (/\d/.test(val[i])) digitsBefore++;
        }

        const newVal = filterDate(val);
        setValue(newVal);
        setIsValid(newVal.length <= 8);
        let isoVal = toValue(newVal);

        if (isoVal) {

        }

        // Allow truncated input...(day and month set to current year)
        if (_truncate && newVal.length === 5) {
            let _v = newVal + "/" + dayjs().format("YY");
            isoVal = toValue(_v);
            setValue(_v);
            setIsValid(_v.length <= 8);
            //onFilled(isoVal);
            return;
        }

        if (isoVal && value.length < 8 && newVal.length === 8) {
            onFilled(isoVal);
            return;
        }

        onChange(isoVal);

        setTimeout(() => {
            const newInput = inputRef.current;
            if (newInput && newInput === input) {
                let newCursorPos = 0;
                let digitCount = 0;
                for (let i = 0; i < newVal.length; i++) {
                    newCursorPos = i + 1;
                    if (/\d/.test(newVal[i])) {
                        digitCount++;
                        if (digitCount >= digitsBefore) break;
                    }
                }
                newInput.setSelectionRange(newCursorPos, newCursorPos);
            }
        }, 0);
    };

    const handleFocus = (e) => {
        setIsFocused(true);
        if (autoselect) {
            const input = e.target;
            const selectionLength = input.selectionEnd - input.selectionStart;
            if (selectionLength === 0 && input.value.length > 0) {
                requestAnimationFrame(() => input.select());
            }
        }
        onFocus();
    };


    const handleBlur = (e) => {
        setIsFocused(false);
        setTimeout(() => {
            onBlur(toValue(value));
        }, 1)
    };

    const nextCycleItem = () => {
        if (!cycle || cycle.length === 0) return "";
        const resolvedCycle = cycle.map(resolveCycleItem);
        const currentInternal = toValue(value);
        const currentIndex = resolvedCycle.indexOf(currentInternal);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % resolvedCycle.length;
        return cycle[nextIndex]; // the label you want to show
    };


    const runCycle = () => {

        if (cycle.length === 0) return;
        const currentInternal = toValue(value);
        const resolvedCycle = cycle.map(resolveCycleItem);
        let currentIndex = resolvedCycle.indexOf(currentInternal);
        let nextIndex;
        if (currentIndex === -1) {
            nextIndex = 0;
        } else {
            nextIndex = (currentIndex + 1) % resolvedCycle.length;
        }
        const nextInternal = resolvedCycle[nextIndex];
        const nextDisplay = toDisplay(nextInternal);

        if(onCycle){
            onCycle(nextInternal)
            return; 
        }
        setValue(nextDisplay);
        setIsValid(true);
        onChange(nextInternal);
        onPreFilled(nextInternal);

        setTimeout(() => {
            const input = inputRef.current;
            if (input) {
                input.setSelectionRange(nextDisplay.length, nextDisplay.length);
            }
        }, 0);
        return;


    }

    const handleKeyDown = (e) => {




        if (e.key === 'PageUp') {
            e.preventDefault();
            onPageUp(e.target.value);
            if(pageupcycle){
                runCycle();
            }
        }

        if (["Backspace", "Delete", "Escape", "Home", "End", "ArrowLeft", "ArrowRight"].includes(e.key)) {
            return;
        }

        // Allow truncated if they hit Enter or Tab
        if (["Enter", "Tab"].includes(e.key)) {


            handleChange(e, true);
            if (onEnter) { if (e?.shiftKey) { return; } onEnter(e.target.value, e); e.target.value = "" }
        }

        if (e.ctrlKey && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;
        if (e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    };

    let _class = edit ? "ui-input edit" : "ui-input";
    if (secondary) _class += " secondary";
    if (warning) _class += " warning";
    if (className) _class += ` ${className}`;
    if (right) _class += " ra";
    if (width) style.width = `${width}px`;
    if (medium) _class += " medium";
    if (black) _class += " black";
    if (!isValid && edit) _class += " error";
    if (grow) style.flexGrow = 1;
    if (!shrink) style.flexShrink = 0;
    if (opened) _class += " select";

    if (edit) {
        return (
            <div style={{ position: "relative", display: "inline-block" }}>

                {show_preset && (
                    <div
                        style={{
                            position: "absolute",
                            top: "-14px",
                            right: "0",
                            fontSize: "12px",
                            color: "var(--border-primary)"
                        }}
                    >
                        <a onClick={runCycle}>{nextCycleItem()}</a>
                    </div>
                )}

                <input
                    type="text"
                    maxLength={8}
                    autoFocus={autofocus && !isFocused}
                    spellCheck={false}
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    ref={(el) => {
                        inputRef.current = el;
                        if (ref) ref(el);
                    }}
                    placeholder={placeholder}
                    style={{ ...style }}
                    className={_class}
                    value={value}
                />

            </div>

        );
    }

    return (
        <div onClick={onClick} style={{ ...style }} className={_class}>
            {render !== false
                ? render
                : !value && placeholder
                    ? <em style={{ opacity: "0.5" }}>{placeholder}</em>
                    : dayjs(value).format("MMMDD-YY")}
        </div>
    );
});

export default DateInput;